<template>
  <div>
    <label
      v-if="label"
      class="form-label text-sm"
      :for="id">{{ label }}:</label>
    <input
      :autocomplete="autocomplete"
      :id="id"
      ref="input"
      :maxlength="maxLength"
      v-bind="$attrs"
      class="form-input"
      :class="[{ error: error, 'bg-gray-200': disabled }, inputClass]"
      :type="type"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)">
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
    label: String,
    error: String,
    inputClass: String,
    maxLength: Number,
    autocomplete: String,
    disabled: Boolean,
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    },
    select () {
      this.$refs.input.select()
    },
    setSelectionRange (start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
